export default [
  {
    name: "Abby",
    rating: 5,
    image: "/user_0.png",
    datetime: "07/12/2020",
    comment:
      "Peter rất chuyên nghiệp và thân thiện, mành anh ấy lắp đặt cho chúng tôi trông rất đẹp mắt. Chất lượng của tấm mành khá tốt và nó tôn lên vẻ đẹp của mái ấm chúng tôi nên nó thực sự đáng từng đồng tiền tôi bỏ ra. Sự độc đáo của chiếc mành khiến cho nó trông thật sự nổi bật. Tôi rất khuyến khích các bạn trải nghiệm Rèm cửa Huy Hoàng.",
  },
  {
    name: "Techsy",
    rating: 5,
    image: "/user_0.png",
    datetime: "05/10/2020",
    comment:
      "Chất lượng sản phẩm tuyệt vời, giá cả cạnh tranh và tôi rất hài lòng với dịch vụ nơi đây.",
  },
  {
    name: "HU-705227543",
    rating: 5,
    image: "/user_0.png",
    datetime: "18/09/2020",
    comment:
      "Tôi sẽ giới thiệu Rèm cửa Huy Hoàng  và sự chuyên nghiệp của họ trong việc nâng tầm nội thất cửa sổ với bạn vè và người thân. Peter đã rất chuyên nghiệp, ân cần và thân thiện khi làm việc với chúng tôi. Anh ấy đã hoàn thành công việc một cách xuất sắc và mang đến cho nhà chúng tôi một dáng vẻ mới với chiếc mành mỏng. Tôi đánh giá cao sự chuyên nghiệp trong cách làm việc của bạn. Xin cảm ơn Peter và nhóm của bạn.",
  },
  {
    name: "Liezl Anne Adriano",
    rating: 5,
    image: "/user_0.png",
    datetime: "15/09/2020",
    comment:
      "Chất liệu tốt và chất lượng. Peter rất chuyên nghiệp và thân thiện. Giá cả cũng rất hợp lý.",
  },
  {
    name: "HU-997726892",
    rating: 4,
    image: "/user_0.png",
    datetime: "11/09/2020",
    comment:
      "Một người bạn đã giới thiệu Rèm cửa Huy Hoàng với chúng tôi và chúng tôi đã liên hệ với họ. Nhân viên ở Rèm cửa Huy Hoàng đã đến để đo đạc cửa sổ của chúng tôi một cách tận tâm. Dù chịu ảnh hưởng của dịch COVID-19 mà mành được hoàn thiện trễ hơn so với dự kiến nhưng Rèm cửa Huy Hoàng đã thông báo cho chúng tôi biết về việc trì hoãn này. Dịch vụ ở đây rất chuyên nghiệp và họ là những con người khá là thân thiện.",
  },
  {
    name: "HU-23821318",
    rating: 5,
    image: "/user_0.png",
    datetime: "28/07/2020",
    comment:
      "Tôi đã có một trải nghiệm rất vui vẻ với Peter ở Rèm cửa Huy Hoàng. Sau khi anh ấy tư vấn cho tôi đa dạng các sản phẩm với mẫu mã và màu sắc khác nhau, tôi đã quyết định chọn Mành Cầu Vồng. Nhờ anh ấy dẫn tôi đến ngắm nhìn trực tiếp một căn nhà mới vừa lắp đặt loại mành này mà tôi càng thêm chắc chắn rằng về sự lựa chọn của bản thân. Việc lắp đặt diễn ra rất nhanh chóng và gọn gàng. Ngôi nhà của tôi trông càng thu hút hơn và mọi thứ hài hòa với nhau đến lạ. Tôi rất hài lòng với dịch vụ ở đây và tôi khuyến khích mọi người làm việc với Peter. Cảm ơn Peter và nhóm của anh.",
  },
  {
    name: "HU-671594530",
    rating: 5,
    image: "/user_0.png",
    datetime: "12/07/2020",
    comment:
      "Chất lượng dịch vụ tuyệt vời, đúng thời hạn, giá cả tối ưu. Tôi đã được giới thiệu đa dạng các loại mành và được tư vấn tận tâm.",
  },
  {
    name: "Li Quan",
    rating: 5,
    image: "/user_0.png",
    datetime: "02/06/2020",
    comment:
      "Chất lượng sản phẩm và dịch vụ tuyệt vời! Tôi rất hài lòng với thành phẩm vì nó hoàn toàn phù hợp với phong cách ngôi nhà mới của tôi. Rèm cửa Huy Hoàng đã hoàn thành công việc một cách gọn gàng và ngăn nắp. Tôi rất khuyến khích các bạn trải nghiệm sản phẩm và dịch vụ ở đây.",
  },
  {
    name: "Nicolas C., Auckland",
    rating: 5,
    image: "/user_0.png",
    datetime: "02/04/2020",
    comment:
      "Sản phẩm tốt, dịch vụ tuyệt vời và giá cả phải chăng! Chúng tôi cảm thấy rất hài lòng vì đã tin tưởng lựa chọn Rèm cửa Huy Hoàng và màn cửa của họ. Tôi đã và sẽ tiếp tục giới thiệu Rèm cửa Huy Hoàng đến với gia đình và bạn bè của tôi.",
  },
  {
    name: "VISHAL AGARWAL",
    rating: 5,
    image: "/user_0.png",
    datetime: "25/03/2020",
    comment:
      "Chất lượng dịch vụ tuyệt vời, sản phẩm tốt, giá cả cạnh tranh, cam kết hoàn thành công việc đúng hạn, việc trao đổi diễn ra rất thuận lợi, sản phẩm và dịch vụ được bảo hành 5 năm.",
  },
  {
    name: "Christine Keown",
    rating: 5,
    image: "/user_0.png",
    datetime: "22/03/2020",
    comment:
      "Mức giá rất hợp lý. Việc trao đổi giữa hai bên diễn ra khá thuận lợi. Sản phẩm tốt và đúng như ý muốn. Nhân viên làm việc với chúng tôi là rất thoải mái và dễ chịu.",
  },
];
